export default "__VITE_ASSET__0b520fc0__"